export default __webpack_public_path__ + "static/media/ecd22190e5eb9628fe3f4f03e5291919.svg";